<form [formGroup]="formGroup">
  <div class="d-flex flex-column gap-4">
    <app-primary-back-button (backClicked)="goBack()" label="Step 2" i18n-label />
    <div class="enrolment-copy" i18n>Enter your email and choose a password to create your SPP account.</div>
    <div class="login-form-container" [hidden]="isLoading$ | async">
      <div class="email-container">
        <div class="email-input">
          <label [for]="'email'" class="form-input-label" i18n>Email Address</label>
          <app-email-input
            formControlName="email"
            controlId="email"
            (valueChange)="emailChanged()"
            [error]="formSubmitted && (formGroup.controls.email.invalid || (emailInUse$ | async))" />
        </div>
        <ng-container *ngIf="formSubmitted && (formGroup.controls.email.invalid || (emailInUse$ | async))">
          <app-form-error *ngIf="!(emailInUse$ | async)" [errors]="formGroup.controls.email.errors" />
          <div class="d-flex gap-2 align-items-center" *ngIf="emailInUse$ | async">
            <img
              src="assets/icons/red/ExclamationCircle.svg"
              alt=""
              height="18"
              width="18"
              [style.height.rem]="1.125"
              [style.width.rem]="1.125" />
            <div class="form-error-text" i18n>
              This email is already in use. Sign in or reset your password on the login page.
            </div>
            <app-tertiary-button [size]="BaseButtonSizeEnum.xs" (buttonClicked)="goToLogin()" i18n>
              Return to Login Page
            </app-tertiary-button>
          </div>
        </ng-container>
      </div>
      <div class="form-grid">
        <div class="d-flex flex-column gap-2">
          <label [for]="'password'" class="form-input-label" i18n>Password</label>
          <app-password-input
            formControlName="password"
            controlId="password"
            [error]="formSubmitted && formGroup.controls.password.invalid" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.password.invalid"
            [customErrorMessages]="customErrorMessages.password"
            [errors]="formGroup.controls.password.errors" />
          <span class="form-input-hint" i18n>
            Must contain 8-50 characters, including 1 number, 1 special character, 1 uppercase letter, and 1 lowercase
            letter
          </span>
        </div>
        <div class="d-flex flex-column gap-2">
          <label [for]="'confirmPassword'" class="form-input-label" i18n>Confirm Password</label>
          <app-password-input
            formControlName="confirmPassword"
            controlId="confirmPassword"
            [error]="formSubmitted && formGroup.controls.confirmPassword.invalid" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.confirmPassword.invalid"
            [errors]="formGroup.controls.confirmPassword.errors" />
        </div>
      </div>
    </div>
    <div class="login-form-container" [hidden]="!(isLoading$ | async)">
      <div class="form-grid">
        <div class="d-flex flex-column gap-2">
          <lib-loading-shimmer [height]="'1.25rem'" [width]="'5rem'" />
          <lib-loading-shimmer [height]="'3.5rem'" [width]="'100%'" />
        </div>
      </div>
      <div class="form-grid">
        <div class="d-flex flex-column gap-2">
          <lib-loading-shimmer [height]="'1.25rem'" [width]="'5rem'" />
          <lib-loading-shimmer [height]="'3.5rem'" [width]="'100%'" />
        </div>
        <div class="d-flex flex-column gap-2">
          <lib-loading-shimmer [height]="'1.25rem'" [width]="'5rem'" />
          <lib-loading-shimmer [height]="'3.5rem'" [width]="'100%'" />
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-2">
      <div class="eula-container" [class.disabled]="isLoading$ | async">
        <app-checkbox-input formControlName="acceptTerms" controlId="acceptTerms" />
        <div class="d-flex align-items-center gap-1">
          <span class="terms-label" i18n>I accept the </span>
          <button type="button" (click)="openEulaModal()" class="no-style-button link-button" i18n>
            Terms and Conditions
          </button>
        </div>
      </div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.acceptTerms.invalid"
        [customErrorMessages]="customErrorMessages.terms"
        [errors]="formGroup.controls.acceptTerms.errors" />
    </div>
    <app-primary-button
      [size]="BaseButtonSizeEnum.md"
      [isLoading]="isLoading$ | async"
      (buttonClicked)="submit()"
      class="submit-button"
      i18n>
      Continue
    </app-primary-button>
  </div>
</form>
